import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RuleIcon from '@mui/icons-material/Rule';
import CancelIcon from '@mui/icons-material/Cancel';

import { PackageDateStatus_packageDate$key } from '__generated__/PackageDateStatus_packageDate.graphql';
import Tooltip from '@mui/material/Tooltip';

type Props = {
  packageDate: PackageDateStatus_packageDate$key;
};

const PackageDateStatus: FC<Props> = props => {
  const { status } = useFragment(
    graphql`
      fragment PackageDateStatus_packageDate on PackageDate {
        status
      }
    `,
    props.packageDate
  );

  return status === 'ACTIVE' ? (
    <Tooltip title="Aktyvi">
      <CheckCircleIcon color="success" />
    </Tooltip>
  ) : status === 'EXPIRED' ? (
    <Tooltip title="Pasibaigęs galiojimas">
      <RuleIcon color="warning" />
    </Tooltip>
  ) : (
    <Tooltip title="Nepilnai užpildyta">
      <CancelIcon color="error" />
    </Tooltip>
  );
};

export default PackageDateStatus;
